import { render, staticRenderFns } from "./ResearchProjectSiteBasicForm.vue?vue&type=template&id=457ae3aa&"
import script from "./ResearchProjectSiteBasicForm.vue?vue&type=script&lang=js&"
export * from "./ResearchProjectSiteBasicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports